import {LoginRequest, userStore} from '../redux/entities/user';
import {api, setToken} from './index';

export interface PasswordResetRequest {
  email: string;
  passwordResetToken: string;
  password: string;
  confirmPassword: string;
}

export const logout = () => () => {
  localStorage.removeItem('token');
  localStorage.removeItem('persist:users');
  userStore.actions.setCurrentUser(null);
};

export async function login(user: LoginRequest) {
  const res = await api.post('authentication', user);
  setToken(res.data.token);
  return res;
}

export async function forgotPassword(email: string) {
  return (await api.post<string>('/user/forgotPassword/' + email)).data;
}

export async function validateToken(token: string) {
  return (await api.get('/user/validateToken/' + token)).data;
}

export async function validateEmailVerificationToken(token: string) {
  return (await api.get('/register/verify/' + token)).data;
}

export async function resetPassword(resetRequest: PasswordResetRequest) {
  return (await api.post('/user/resetPassword', resetRequest)).data;
}

export async function resetAuthenticatedPassword(resetRequest: Omit<PasswordResetRequest, 'passwordResetToken'>) {
  return (await api.post('/user/resetAuthenticatedPassword', resetRequest)).data;
}

export async function getCurrentUserFromServer() {
  return (await api.get('/user/current')).data;
}
